import { alternateaddress } from './alternateaddress';
import { benefit } from './benefit';
import { branch } from './branch';
import { checkbox } from './checkbox';
import { checkboxgroup } from './checkboxgroup';
import { civilunion } from './civilunion';
import { clearancelevel } from './clearancelevel';
import {
  collection, emailCollection, telephoneCollection, foreignPassportCollection
} from './collection';
import { contacts } from './contacts';
import { coowners } from './coowners';
import { country } from './country';
import { datecontrol } from './datecontrol';
import { daterange } from './daterange';
import { email } from './email';
import { employmentactivity } from './employmentactivity';
import { foreignborndocument } from './foreignborndocument';
import { general } from './general';
import { height } from './height';
import { location } from './location';
import { name } from './name';
import { notapplicable } from './notapplicable';
import { number } from './number';
import { passports, passport } from './passports';
import { physicaladdress } from './physicaladdress';
import { treatment } from './treatment';
import { radio } from './radio';
import { reasonleft } from './reasonleft';
import { sentence } from './sentence';
import { ssn } from './ssn';
import { supervisor } from './supervisor';
import { telephone } from './telephone';
import { text } from './text';
import { textarea } from './textarea';
import { signature } from './signature';

export {
  alternateaddress,
  benefit,
  branch,
  checkbox,
  checkboxgroup,
  civilunion,
  clearancelevel,
  collection,
  contacts,
  coowners,
  country,
  datecontrol,
  daterange,
  email,
  emailCollection,
  employmentactivity,
  foreignborndocument,
  foreignPassportCollection,
  general,
  height,
  location,
  name,
  notapplicable,
  number,
  passport,
  passports,
  physicaladdress,
  treatment,
  radio,
  reasonleft,
  sentence,
  ssn,
  supervisor,
  telephone,
  telephoneCollection,
  text,
  textarea,
  signature,
};
